/* Read more / Read less for clamped SEO copy: <div data-readmore data-more="…" data-less="…"> */
const CLAMP = 300;

function init(root) {
  if (root.dataset.ready) return;
  root.dataset.ready = 'true';
  const body = root.querySelector('.otw-seo__body');
  const toggle = root.querySelector('[data-readmore-toggle]');
  if (!body || !toggle) return;

  const measure = () => {
    if (root.classList.contains('is-open')) return;
    const overflows = body.scrollHeight > CLAMP + 40;
    root.classList.toggle('is-clamped', overflows);
    toggle.hidden = !overflows;
  };

  toggle.addEventListener('click', () => {
    const open = !root.classList.contains('is-open');
    root.classList.toggle('is-open', open);
    root.classList.toggle('is-clamped', !open);
    toggle.setAttribute('aria-expanded', String(open));
    toggle.textContent = open ? root.dataset.less : root.dataset.more;
    if (!open) root.scrollIntoView({ block: 'nearest' });
  });

  measure();
  window.addEventListener('load', measure);
  if ('ResizeObserver' in window) new ResizeObserver(measure).observe(body);
}

const boot = () => document.querySelectorAll('[data-readmore]').forEach(init);
boot();
document.addEventListener('shopify:section:load', boot);
